<template>
    <normal-page name="Press">
        <div class="grid items-center gap-4 sm:gap-6 sm:grid-cols-2 lg:gap-8">
            <template
                v-for="(isLoaded, imagePath) in imagePaths"
                :key="imagePath"
            >
                <enlarge-image
                    class="mx-auto w-full max-w-[382px]"
                    :src="imagePath"
                    :isForceLoadFull="Object.values(imagePaths).every(isLoaded => isLoaded)"
                    @thumbnailLoaded="imagePaths[imagePath] = true"
                />
            </template>
        </div>
    </normal-page>
</template>

<script>
    // Components
    import { defineComponent, ref } from 'vue';
    import NormalPage from '@/components/layout/pages/NormalPage';
    import EnlargeImage from '@/components/plugins/EnlargeImage';
    // Library

    export default defineComponent({
        name: 'PressView',

        components: {
            EnlargeImage,
            NormalPage,
        },

        setup() {
            const imagePaths = ref({
                'img/press/press1.jpg': false,
                'img/press/press2.jpg': false,
                'img/press/press3.jpg': false,
                'img/press/logo-shade-background.jpg': false,
            });

            return {
                imagePaths,
            };
        },
    });
</script>
